import React from 'react';
import './App.css';

const url="https://qlnm6t9vt0.execute-api.sa-east-1.amazonaws.com/dev/forgot/confirm"
class Confirm extends React.Component {

    constructor(props){
        super(props);
        this.state={
            token:props.match.params.token,
            altered:false,
            isAltering:true
        }
    }




    componentDidMount () {
        console.log(this.props.match.params.token)
        if(this.props.match.params.token){
            if(this.props.match.params.token.length===128){
                fetch(url,{
                    method:"POST",
                    body:JSON.stringify({token:this.props.match.params.token})
                }).then(response=>{return response.json()}).then(response=>{
                    if(response.statusCode===200){
                        this.setState({isAltering:false,altered:true})
                    }
                })
            }
        }
    }
    render(){
        if(this.state.token){
            if(this.state.token.length===128){
                if(this.state.isAltering){
                    return (
                        <div>Alterando...</div>
                    )
                }else if(this.state.altered){
                    return (
                        <div> Senha alterada com sucesso. Verifique o email</div>
                    )
                }else{
                    return(
                        <div>
                            Não pudemos alterar a senha.....
                        </div>
                    )
                }
            }
        }
        return (
            <div>
                <h4>Ooops. Algo não está correto</h4>
                <p>O link para alteração de senha parece estar incorreto.</p>
                <p>Verifique se copiou ou clicou no link correto no teu e-mail.</p>
                <p>Se não tiver o link em mãos, solicite alteração de senha novamente.</p>
                <p>Não permitimos mais de uma solicitação a cada 20 minutos.</p>
            </div>
        )


    }

    // return (
    //   <div className="App">
    //     <header className="App-header">
    //       <img src={logo} className="App-logo" alt="logo" />
    //       <p>
    //         Edit <code>src/App.js</code> and save to reload.
    //       </p>
    //       <a
    //         className="App-link"
    //         href="https://reactjs.org"
    //         target="_blank"
    //         rel="noopener noreferrer"
    //       >
    //         Learn React
    //       </a>
    //     </header>
    //   </div>
    // );
}

export default Confirm;
